import * as React from 'react';

import {IconAvatar} from '../avatar/icon-avatar';
import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {MinusIcon} from '../icon/svg/minus-icon';
import {Popover} from '../popover/popover';

import {NudgeInput} from './nudge-input';

import styles from './chat-preview.module.css';

type Props = {
    isChatOpen: boolean;
    openIcon: React.ReactNode | string;
    backgroundColor: string;
    showNudge?: boolean;
    nudgeText?: string;
    appearanceCallToAction?: string;
};

export function ChatToggleButton(props: Props) {
    const [shouldShowNudge, setShouldShowNudge] = React.useState(false);

    const popoverRef = React.useRef();

    React.useLayoutEffect(() => {
        if (popoverRef && popoverRef.current) {
            // @ts-expect-error
            setShouldShowNudge(props.showNudge);
        }
    }, [popoverRef, props.showNudge]);

    return (
        <>
            <div className={styles['icon-avatar-container']}>
                {/* @ts-expect-error */}
                <div ref={popoverRef} className='flex gap-8'>
                    {shouldShowNudge && NutClientConfig.hasNudgesForChatFF && (
                        <NudgeInput
                            appearanceColor={props.backgroundColor}
                            appearanceCallToAction={props.appearanceCallToAction}
                        />
                    )}
                    <IconAvatar
                        backgroundColor={props.backgroundColor}
                        iconColor={colors.white}
                        iconSize={30}
                        avatarSize={60}
                        customIcon={props.isChatOpen ? undefined : props.openIcon}
                        icon={props.isChatOpen ? MinusIcon : undefined}
                        shape='square'
                        squareBorderRadius={8}
                    />
                </div>
            </div>
            {shouldShowNudge && !NutClientConfig.hasNudgesForChatFF && (
                <Popover offsetPosition={8} anchor={popoverRef.current} location='left'>
                    <div className={styles['popover-text']}>{props.nudgeText}</div>
                </Popover>
            )}
        </>
    );
}
